import type { CheckoutProps } from "../CheckoutProps";
import { useOverrideFeatureFlag } from "./useOverrideFeatureFlag";

export const useIsPaywallsCheckoutCustomizationPhase1Enabled = ({
  isPaywallsCheckoutCustomizationPhase1Enabled,
}: CheckoutProps) => {
  const featureFlagsOverride = useOverrideFeatureFlag({
    isPaywallsCheckoutCustomizationPhase1Enabled,
  });

  return featureFlagsOverride.isPaywallsCheckoutCustomizationPhase1Enabled;
};
